import { SquarePen, Timer, Dices } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import FoglioMenu, { type Voce } from './FoglioMenu';

/**
 * Il menu di «Strumenti», il foglio che sale dalla quarta voce della barra.
 *
 * Tre attrezzi che non sono una partita: comporre una posizione (l'editor, che
 * prima era la voce di barra e adesso e' la prima riga di questo foglio),
 * l'orologio da tavolo e il sorteggio di un'apertura. Gli ultimi due servono
 * una partita giocata DAL VIVO, su una damiera vera, con questo telefono
 * appoggiato accanto: e' la ragione per cui non stanno nel foglio di «Gioca»,
 * che e' l'indice delle partite che si giocano QUI.
 *
 * Come «Gioca», e' un INDICE e non una porta: nessuna riga costruisce la sua
 * destinazione. Il cablaggio sta in App.tsx, l'unico posto che puo' cambiare
 * schermata — compreso il gate della prima riga, che e' lo stesso che decide se
 * la voce di barra esiste.
 *
 * Nessuna riga chiede la rete: tutti e tre girano sul dispositivo. Per questo il
 * foglio non si spegne mai, e non mostra la riga «sei senza rete» che il foglio
 * di «Gioca» alza sopra le sue quattro righe online.
 */
interface Props {
  isOpen: boolean;
  onClose: () => void;
  onEditor: () => void;
  onOrologio: () => void;
  onEstraiApertura: () => void;
}

export default function FoglioStrumenti({
  isOpen,
  onClose,
  onEditor,
  onOrologio,
  onEstraiApertura,
}: Props) {
  const { t } = useTranslation();

  const voci: Voce[] = [
    /* `nav.editor` e' la chiave della voce di barra che questa riga ha
       sostituito: gia' tradotta in otto lingue, e la stessa parola che l'utente
       leggeva prima nello stesso punto dello schermo. */
    { id: 'editor', icona: <SquarePen size={20} />, etichetta: t('nav.editor'), azione: onEditor },
    /* `Timer` e non `AlarmClock`: in tutta l'app questo glifo vuol dire «il
       tempo di una partita» (la riga della cadenza, le intestazioni dell'arena,
       il cartellino del giocatore), mentre la sveglia e' gia' presa dal suono
       del tempo basso nelle preferenze. */
    { id: 'orologio', icona: <Timer size={20} />, etichetta: t('strumenti.orologio'), azione: onOrologio },
    /* I dadi sono gia' l'icona dell'apertura sorteggiata, nel cartellino che la
       annuncia sopra la damiera (DrawnOpeningBanner): stessa cosa, stessa
       icona. */
    { id: 'apertura', icona: <Dices size={20} />, etichetta: t('strumenti.estraiApertura'), azione: onEstraiApertura },
  ];

  return (
    <FoglioMenu
      isOpen={isOpen}
      onClose={onClose}
      titolo={t('strumenti.titoloFoglio')}
      testId="foglio-strumenti"
      voci={voci}
    />
  );
}
